import { render, staticRenderFns } from "./client-added.vue?vue&type=template&id=aeaacea0&scoped=true&"
import script from "./client-added.vue?vue&type=script&lang=js&"
export * from "./client-added.vue?vue&type=script&lang=js&"
import style0 from "./client-added.vue?vue&type=style&index=0&id=aeaacea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaacea0",
  null
  
)

component.options.__file = "client-added.vue"
export default component.exports